<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2><span class="h2-inner">From Hanno’s memoir</span></h2>
<p class="firstInSection">The characters were strange. Bostar had started teaching me spoken Punic as soon as we left Capua. And an old Carthaginian merchant from the nearby town of Amphipolis came each day for conversation while Bostar was away. Then I began to learn the writing. Punic was my father’s language, of course, although he spoke many more. Greek was his polyglot army’s language of command, but I know from Bostar how he could even talk to the Gauls in their own guttural tongue. Anyway, I studied Punic to help take away the pain. Bostar spent most of each day in his room writing letters. Two or three messengers came and went most days, and the captain Trimalchio was often with us too, shut up with Bostar in his room. I remember thinking I might write to my mother in my new-found Punic. But then I realised. She would not understand.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?abc5a094